import { data, type } from "jquery";
import { getCookie, addCookie, setCookie } from "@/ask/cookiejs.js";
import { post, fetch } from "@/ask/axios";
import { fileSteamDownload } from "@/util/download";

export default {
  install(Vue, options) {
    (Date.prototype.Format = function (fmt) {
      if (!this.Valid()) {
        return "";
      }

      var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      }
      return fmt;
    }),
      //判断是否有效日期
      (Date.prototype.Valid = function () {
        return isFinite(this);
      });
    //注意：此方法会导致阻塞，请慎用
    //等待funCheck的验证通过后，执行funRun
    //funCheck验证方法，此方法必须返回bool型
    //funRun需执行的方法
    //maxWaitMillisecond最多等待时间（单位：毫秒）
    (Vue.prototype.waitRun = function (funCheck, funRun, maxWaitMillisecond) {
      //console.log(maxWaitMillisecond + " " + new Date());
      if (maxWaitMillisecond == null || maxWaitMillisecond == undefined) {
        maxWaitMillisecond = 1000 * 10; //默认最多等待10秒
      }

      if (funCheck() == true || maxWaitMillisecond <= 0) {
        //验证通过，或等待时间已过 执行方法
        funRun();
      } else {
        //验证不通过，等待
        setTimeout(() => {
          this.waitRun(funCheck, funRun, maxWaitMillisecond - 100);
        }, 100);
      }
    }),
      //当小数不足bit时，不补0，超过bit 截取bit位
      // num 数字  bit 位数
      (Vue.prototype.InterceptUnit = function (num, bit) {
        if (num) {
          return parseFloat(Number(num).toFixed(bit));
        } else {
          return 0;
        }
      }),
      /**
       * 获取上N个月
       *
       * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
       * monthNum 要上N个月
       */
      (Vue.prototype.getPreMonth = function (date, monthNum) {
        // console.log('days= ' + JSON.stringify(date));
        var arr = date.split("-");
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);

        days = days.getDate(); //获取当前日期中月的天数
        var year2 = year;
        var month2 = parseInt(month) - monthNum;
        if (month2 == 0) {
          year2 = parseInt(year2) - 1;
          month2 = 12;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
          day2 = days2;
        }
        if (month2 < 10) {
          month2 = "0" + month2;
        }
        var t2 = year2 + "-" + month2 + "-" + day2;
        console.log("t2= " + JSON.stringify(new Date(t2).Format("yyyy-MM-dd")));
        return t2;
      }),
      /**
       * 获取下一个月
       *
       * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
       */
      (Vue.prototype.getNextMonth = function (date) {
        var arr = date.split("-");
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中的月的天数
        var year2 = year;
        var month2 = parseInt(month) + 1;
        if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
          day2 = days2;
        }
        if (month2 < 10) {
          month2 = "0" + month2;
        }

        var t2 = year2 + "-" + month2 + "-" + day2;
        return t2;
      });
    // Currency 1：CNY，2：USD，3：HKD，4：EUR
    Vue.prototype.getMoneySymbol = function (index) {
      let i = Number(index);
      let moneySymbol = ["¥", "US $", "HK $", "€"];
      return moneySymbol[i - 1];
    };
    (Vue.prototype.newDate = function (data) {
      // 返回正确得日期格式
      if (data) {
        data = data.replace(new RegExp(/-/gm), "/");
        // 如果来得格式
        if (data.indexOf("T") !== -1) {
          data = data.replace(new RegExp(/T/gm), " ");
        }
        return new Date(data);
      } else {
        return new Date();
      }
    }),
      (Vue.prototype.dateChange = function (num = 0, date = false) {
        if (!date) {
          date = new Date(); //没有传入值时,默认是当前日期
          date =
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate();
          return date;
        }
        let getDate = date;
        getDate += " 00:00:00";
        getDate = Date.parse(new Date(date)) / 1000;
        getDate += 86400 * num; //修改后的时间戳
        var newDate = new Date(parseInt(getDate) * 1000);
        let giveDate =
          newDate.getFullYear() +
          "-" +
          (newDate.getMonth() + 1) +
          "-" +
          newDate.getDate();
        return giveDate;
      }),
      /**
       * @description: 去除所有空格
       * @param {String} val
       * @return {String}
       */
      (Vue.prototype.removeSpaces = function (val) {
        if (Object.prototype.toString.call(val) !== "[object String]") {
          console.error(val + " must need string, plz");
        } else {
          return String(val).replace(/\s+/g, "");
        }
      });

    //=============埋点查询=====================//
    let isLogin = false;
    if (getCookie("X-JWT-TOKEN") !== "null") {
      isLogin = true;
    }
    let SalesInfos = JSON.parse(sessionStorage.getItem("SalesInfos"));
    //登录后获取值
    if (SalesInfos) {
      sensors.login(SalesInfos.CustomerID);
    }

    //console.log('getCookie:===  ' + isLogin);
    //注册公共属性 初始化一次
    sensors.registerPage({
      platform_type: "web",
      app_name: "电商web端",
      is_vip: false,
      is_login: isLogin,
    });
    //点击注册获取入口
    Vue.prototype.clkRegBtn = function () {
      let enter = document.title;
      if (document.title === "客户注册_百运网") {
        enter = "新人活动";
      }
      sensors.track("register_button_click", {
        entrance: enter,
      });
    };

    //点击按钮进行验证   神策
    Vue.prototype.sdClickToVerify = function ({ is_success, fail_reason }) {
      sensors.track("click_to_verify", {
        is_success: is_success,
        fail_reason: fail_reason,
      });
    };
    //埋点-点击用户指南
    Vue.prototype.userGuide = function (
      entrance,guideType,isSuccess
    ) {
      sensors.track('user_guide', {
        entrance:entrance,
        guide_type:guideType,
        is_success:isSuccess,
      });
    };
    //埋点查价
    Vue.prototype.CheckPrice = function (
      transType,
      startText,
      startCountry,
      desText,
      desCountry,
      packetType,
      weight,
      cbm,
      quantity,
      isGoods,
      goodsText,
      clearance,
      airType
    ) {
      // debugger
      sensors.track("price_query", {
        entrance: document.title,
        service_type_trans: transType,
        location_of_departure: startText, //出发地
        country_of_departure: startCountry || "中国", //出发国家
        location_of_destination: desText, //目的地的
        country_of_destination: desCountry, //目的国家
        package_type: packetType, //包裹类型
        weight: Number(weight),
        volume: Number(cbm),
        total_number: Number(quantity),
        contain_prohibited_goods_or_not: isGoods,
        goods_contain: goodsText,
        is_need_customs_clearance: clearance, //是否需要清关服务
        air_service_type: airType, //空运服务类型
      });
    };

    //埋点-返回搜索结果
    Vue.prototype.result = function (
      number,
      transType,
      startText,
      startCountry,
      desText,
      desCountry,
      preferred,
      weight,
      cbm
    ) {
      sensors.track("search_result", {
        results_number: Number(number),
        service_type_trans: transType,
        location_of_departure: startText, //出发地
        country_of_departure: startCountry, //出发国家
        location_of_destination: desText, //目的地的
        country_of_destination: desCountry, //目的国家
        contain_preferred_or_not: preferred, //是否百运优选
        weight: weight,
        volume: cbm,
      });
    };

    //埋点-查看渠道详情
    Vue.prototype.viewDetails = function (
      transType,
      mode,
      channelName,
      startText,
      startCountry,
      desText,
      desCountry,
      aging,
      totalPrice,
      channelCategory,
      preferred,
      price
    ) {
      sensors.track("click_for_detail", {
        //position_id: Number(number),
        service_type_trans: transType,
        transport_mode: mode,
        channel_name: channelName,
        location_of_departure: startText, //出发地
        country_of_departure: startCountry, //出发国家
        location_of_destination: desText, //目的地的
        country_of_destination: desCountry, //目的国家
        aging: Number(aging),
        total_price: Number(totalPrice),
        channel_category: channelCategory,
        is_preferred: preferred, //是否百运优选
        price_per_KG: Number(price),
      });
    };

    //埋点-提交订单
    Vue.prototype.submitOrder = function (
      orderId,
      orderAmount,
      orderActualAmount,
      transType,
      startText,
      startCountry,
      desText,
      desCountry,
      goodsType,
      weight,
      volume,
      totalNumber,
      billingW,
      invType,
      channelName,
      costs,
      discountName,
      discountAmount,
      isUseDiscount,
      entrance
    ) {
      //console.log('SalesInfos ' +  JSON.stringify(SalesInfos));

      sensors.track("submit_order", {
        order_id: orderId,
        order_amount: Number(orderAmount),
        order_actual_amount: Number(orderActualAmount),
        service_type_trans: transType,
        location_of_departure: startText, //出发地
        country_of_departure: startCountry, //出发国家
        location_of_destination: desText, //目的地的
        country_of_destination: desCountry, //目的国家
        goods_type: goodsType,
        weight: Number(weight),
        volume: Number(volume),
        total_number: Number(totalNumber),
        billing_w: Number(billingW),
        inv_type: invType,
        saller: SalesInfos != null ? SalesInfos.SalesName : "",
        customer_service: SalesInfos != null ? SalesInfos.KFName : "",
        channel_name: channelName,
        transportation_costs: Number(costs),
        discount_name: discountName,
        discount_amount: Number(discountAmount),
        is_use_discount: isUseDiscount,
        entrance: entrance == null ? document.title : entrance,
      });
    };

    //埋点-提交询价
    Vue.prototype.submitInquiry = function (
      startText,
      startCountry,
      desText,
      desCountry,
      intype,
      weight,
      serviceType,
      custType,
      volume,
      billingW,
      totalNumber,
      goodsType,
      entrance
    ) {
      sensors.track("inquiry", {
        location_of_departure: startText, //出发地
        country_of_departure: startCountry, //出发国家
        location_of_destination: desText, //目的地的
        country_of_destination: desCountry, //目的国家
        inquiry_type: intype, //询问类型
        weight: Number(weight),
        service_type: serviceType,
        cust_type: custType,
        volume: Number(volume),
        billing_w: Number(billingW),
        total_number: Number(totalNumber),
        goods_type: goodsType,
        entrance: entrance,
      });
    };

    //埋点-浏览询盘结果
    Vue.prototype.viewResult = function (
      inquiryId,
      startText,
      startCountry,
      desText,
      desCountry,
      weight,
      serviceType,
      volume,
      billingW,
      totalNumber,
      goodsType
    ) {
      sensors.track("view_inquiry_result", {
        inquiry_id: inquiryId,
        location_of_departure: startText, //出发地
        country_of_departure: startCountry, //出发国家
        location_of_destination: desText, //目的地的
        country_of_destination: desCountry, //目的国家
        weight: Number(weight),
        service_type: serviceType,
        volume: Number(volume),
        billing_w: Number(billingW),
        total_number: Number(totalNumber),
        goods_type: goodsType,
      });
    };

    //埋点-首页banner
    Vue.prototype.clkBanner = function (
      pageType,
      belongArea,
      bannerName,
      bannerId,
      url,
      positionId
    ) {
      sensors.track("banner_click", {
        page_type: document.title,
        banner_belong_area: belongArea,
        banner_type: "广告图片",
        banner_name: bannerName,
        banner_id: bannerId,
        url: url,
        position_id: positionId,
      });
    };

    //埋点-新闻浏览
    Vue.prototype.newsView = function (
      newsTitle,
      newsType,
      positionModule,
      positionId
    ) {
      sensors.track("news_view", {
        news_title: newsTitle,
        news_type: newsType,
        position_module: positionModule,
        position_id: positionId,
      });
    };
    //埋点-特价和热卖点击
    Vue.prototype.clkSpecial = function (serviceType, price, items, expType) {
      sensors.track(expType === "hot" ? "hot_number_click" : "special_click", {
        service_type_trans: serviceType,
        price_per_KG: Number(price),
        page_type: document.title,
        channel_name: items.ChannelName,
        location_of_destination: items.DestName,
        location_of_departure: items.StartName,
      });
    };

    //埋点-偏远地区查询
    Vue.prototype.clkRremote = function (
      postcode,
      country,
      location,
      resultsNnumber
    ) {
      sensors.track("remote_add", {
        postcode: postcode,
        country_of_destination: country,
        location_of_destination: location,
        results_number: Number(resultsNnumber),
        entrance: document.title,
      });
    };

    //注册结果
    //定制埋点--注册是否成功
    Vue.prototype.registerResult = function (type, IsOK, Message) {
      sensors.track("register_result", {
        registration: type,
        is_success: IsOK,
        fail_reason: Message,
      });
    };
    //埋点-一键下单点击
    Vue.prototype.clkOneorder = function (
      positionModule,
      serviceTypeTrans,
      locationOfDes,
      //results,
      entrance
    ) {
      sensors.track("One_order_click", {
        position_module: positionModule, //位置模块
        service_type_trans: serviceTypeTrans, //物流业务类型
        location_of_destination: locationOfDes, //目的地
        //results: results,//结果
        entrance: entrance, //入口
      });
    };



    // 特惠商品点击埋点事件
    Vue.prototype.discountsClick = function (pageType, channelName, entrance) {
      // console.log(pageType, channelName, entrance);
      sensors.track("discounts_click", {
        page_type: pageType, // 页面title
        channel_name: channelName,
        entrance: entrance, // 限时特惠、特惠挂件、查价列表
      });
    };

    Vue.prototype.$TrackPoint = function (callback) {
      try {
        let data = callback();
        //console.log("🚀 ~ data", data)

        sensors.track(data[0], data[1]);
      } catch (err) {
        console.error('埋点报错', err);
      }
    };

    //客服
    Vue.prototype.SDInstantMessaging = function () {
      try {
        sensors.track("instant_messaging", {
          entrance: document.title,
        });
      } catch (error) {
        console.log("🚀 ~ 客服error", error);
      }
    };

    /**
     * @description: 倒计时计算
     * @param { string } type: 表示获取倒计时的天、时、分、秒，可以传递的值有 days: 天；hours: 时；minutes: 分；seconds: 秒
     * @param { number } site：表示获取对应时间的第几位数值
     * @param { date } nowTime: 表示现在的时间
     * @param { date } expectedTime: 表示截止时间
     * @return { number } 时间数值
     */
    Vue.prototype.getCountdown = function (type, site, nowTime, expectedTime) {
      let startTime = nowTime; // 开始时间
      // 防止结束时间小于开始时间
      let expectedTimeSecond = new Date(expectedTime).getTime();
      let startTimeSecond = new Date(startTime).getTime();
      let endTimeFormat =
        expectedTimeSecond - startTimeSecond <= 0
          ? "2999-10-01 00:00:00"
          : expectedTime;
      let endTime = new Date(endTimeFormat); // 结束时间
      let usedTime = endTime - startTime; // 相差的毫秒数
      let days = Math.floor(usedTime / (24 * 3600 * 1000)); // 计算出天数
      let time = usedTime % (24 * 3600 * 1000); // 计算天数后剩余的时间
      let hours = Math.floor(time / (3600 * 1000)); // 计算剩余的小时数
      let time2 = time % (3600 * 1000); // 计算剩余小时后剩余的毫秒数
      let minutes = Math.floor(time2 / (60 * 1000)); // 计算剩余的分钟数
      let time3 = time2 % (60 * 1000); // 计算剩余分钟后剩余的毫秒数
      let seconds = Math.floor(time3 / 1000); // 计算剩余分钟后剩余的毫秒数
      let dateTimeList = {
        days,
        hours,
        minutes,
        seconds,
      };
      let dateTime = String(dateTimeList[type]);
      if (dateTime.length > 1) {
        if (dateTime.length > 2) {
          // 若天数大于两位取最后两位
          let dataTimeArray = dateTime.split("");
          let len = dataTimeArray.length;
          return site > 1 ? dataTimeArray[len - 1] : dataTimeArray[len - 2];
        }
        return dateTime.split("")[site - 1];
      } else {
        return site > 1 ? dateTimeList[type] : 0;
      }
    };

    // 网页跳转/下载函数
    Vue.prototype.browserHref = function (href, type = 1, fileName = "") {
      // 创建一个a标签下载文件
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = href;
      // 设置a标签target属性
      if (type == 2) {
        link.setAttribute("target", "_blank");
      }
      // 设置文件名称、后缀名
      if (type == 3) {
        link.download = decodeURIComponent(fileName);
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    //     sensors.track(data[0], data[1]);
    //   } catch (err) {
    //     console.error("埋点报错", err);
    //   }
    // };
  },
};
//随机生成手机号
export function getMoble() {
  var prefixArray = new Array(
    "130",
    "131",
    "132",
    "133",
    "135",
    "137",
    "138",
    "170",
    "187",
    "189"
  );

  var i = parseInt(10 * Math.random());

  var prefix = prefixArray[i];
  prefix = prefix + "****";
  for (var j = 0; j < 4; j++) {
    prefix = prefix + Math.floor(Math.random() * 10);
  }
  prefix;
  return prefix;
}

// 以下JS函数用于获取url参数:
export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
//去除字符串中的字母
export function dislodgeLetter(str) {
  var result;
  var reg = /[a-zA-Z]+/; //[a-zA-Z]表示匹配字母，g表示全局匹配
  while ((result = str.match(reg))) {
    //判断str.match(reg)是否没有字母了
    str = str.replace(result[0], ""); //替换掉字母  result[0] 是 str.match(reg)匹配到的字母
  }
  return str;
}
/*
 * 获取今天，明天，后天的日期 num 为-1 昨天  num为-2 前天
 * TimeStart 开始服务时间 由后台数据返回
 * TimeEnd 结束服务时间 由后台数据返回
 */
export function getDay(num, str, TimeStart, TimeEnd, strTime = ":") {
  var dayTime = new Date();
  dayTime.setTime(dayTime.getTime() + 24 * 60 * 60 * 1000 * num);
  // 计算三天日期
  let year, month, day, dayData;
  year = dayTime.getFullYear();
  month =
    dayTime.getMonth() + 1 < 10
      ? "0" + (dayTime.getMonth() + 1)
      : dayTime.getMonth() + 1;
  day = dayTime.getDate() < 10 ? "0" + dayTime.getDate() : dayTime.getDate();
  dayData = year + str + month + str + day;
  // 当前日期 时间
  let dayNew = new Date();
  let yearNew, monthNew, daysNew, dayDataNew, HH, MM;
  yearNew = dayNew.getFullYear();
  monthNew =
    dayNew.getMonth() + 1 < 10
      ? "0" + (dayNew.getMonth() + 1)
      : dayNew.getMonth() + 1;
  daysNew = dayNew.getDate() < 10 ? "0" + dayNew.getDate() : dayNew.getDate();
  dayDataNew = yearNew + str + monthNew + str + daysNew;
  // let newtoLocale = dayNew.toLocaleDateString().replace(/\//g, '-');

  MM =
    dayTime.getMinutes() < 10
      ? "0" + dayTime.getMinutes()
      : dayTime.getMinutes();
  HH = dayTime.getHours() < 10 ? "0" + dayTime.getHours() : dayTime.getHours();

  var newHours =
    (MM > 30 ? parseInt(HH, 10) + 1 : HH) +
    strTime +
    (MM > 30 ? parseInt(MM, 10) - 30 : parseInt(MM, 10) + 30) +
    strTime +
    "00";
  // 常规24小时 加半个小时
  let HTimes = [];
  let Time = {};
  let dayHour = 0;
  for (var j = 0; j < 48; j++) {
    if (j < 10 * 2) {
      if (j % 2 == 0) {
        dayHour = "0" + parseInt(j / 2) + ":" + "00" + ":" + "00";
      } else {
        dayHour = "0" + parseInt(j / 2) + ":" + "30" + ":" + "00";
      }
    } else {
      if (j % 2 == 0) {
        dayHour = parseInt(j / 2) + ":" + "00" + ":" + "00";
      } else {
        dayHour = parseInt(j / 2) + ":" + "30" + ":" + "00";
      }
    }
    Time = {
      Time: dayHour,
    };
    HTimes.push(Time);
  }
  // 根据后台返回时间范围计算时间
  let addTime = [];
  // console.log(dayDataNew, "71s", dayData,"4",newHours)
  HTimes.forEach((items) => {
    if (TimeEnd) {
      if (TimeStart <= items.Time && items.Time <= TimeEnd) {
        if (dayDataNew == dayData) {
          if (newHours < items.Time) {
            console.log(newHours, "sjsdj", items.Time);
            addTime.push(items);
          }
        } else {
          addTime.push(items);
        }
      }
    } else {
      if (dayDataNew == dayData) {
        if (newHours < items.Time) {
          addTime.push(items);
        }
      } else {
        addTime.push(items);
      }
    }
  });

  var dayTimeS = {
    Date: dayData,
    Times: addTime,
  };

  return dayTimeS;
}

//查价-- 比重段匹配值 45  XX表示当前数值
export function getProportionKG(XX) {
  XX = Number(XX);
  let ProportionValue = "";
  // 45KG +
  if (XX < 45 || (45 <= XX && XX <= 99)) {
    ProportionValue = 45;
  }

  // 100KG +
  if (100 <= XX && XX <= 299) {
    ProportionValue = 100;
  }

  // 300KG +
  if (300 <= XX && XX <= 499) {
    ProportionValue = 300;
  }

  // 500KG+
  if (500 <= XX && XX <= 999) {
    ProportionValue = 500;
  }

  // 1000KG+
  if (1000 <= XX) {
    ProportionValue = 1000;
  }
  return ProportionValue;
}
//详情tab切换-- 比重段匹配值 1:300  XX表示当前数值
export function getProportionCBM(XX) {
  XX = Number(XX);
  let ProportionValue = "";
  // 默认重量 167KG
  if (XX < 300) {
    ProportionValue = 167;
  }

  // 默认重量 300KG
  if (300 <= XX && XX <= 499) {
    ProportionValue = 300;
  }

  // 默认重量 500KG
  if (500 <= XX && XX <= 999) {
    ProportionValue = 500;
  }

  // 默认重量 1000KG
  if (1000 <= XX) {
    ProportionValue = 1000;
  }

  return ProportionValue;
}

// // 传入一个数组
// // 按照特定方式格式化
// export function sortArr(arr, str) {
//     var _arr = [],
//         _t = [],
//         // 临时的变量
//         _tmp;

//      // 按照特定的参数将数组排序将具有相同值得排在一起
//      arr = arr.sort(function(a, b) {
//          var s = a[str],
//              t = b[str];

//          return s < t ? -1 : 1;
//      });

//      if ( arr.length ){
//          _tmp = arr[0][str];
//      }
//      // console.log( arr );
//      // 将相同类别的对象添加到统一个数组
//      for (var i in arr) {
//          // console.log( _tmp);
//          if ( arr[i][str] === _tmp ){
//              // console.log(_tmp)
//              _t.push( arr[i] );
//          } else {
//              _tmp = arr[i][str];
//              _arr.push( _t );
//              _t = [arr[i]];
//          }
//      }
//      // 将最后的内容推出新数组
//      _arr.push( _t );
//      return _arr;
//  }

// 传入一个数组
// 按照特定方式格式化
export function sortArr(arr, str, str1) {
  var _arr = [],
    _t = [],
    // 临时的变量
    _tmp,
    _tmp1,
    // 按照特定的参数将数组排序将具有相同值得排在一起
    arr = arr.sort(function (a, b) {
      var s = a[str],
        t = b[str];

      var s1 = a[str1],
        t1 = b[str1];

      return (s < t ? -1 : 1) && (s1 < t1 ? -1 : 1);
    });

  if (arr.length) {
    _tmp = arr[0][str];
    _tmp1 = arr[0][str1];
  }

  console.log(arr);

  // 将相同类别的对象添加到统一个数组
  for (var i in arr) {
    if (arr[i][str] === _tmp && arr[i][str1] === _tmp1) {
      _t.push(arr[i]);
    } else {
      _tmp = arr[i][str];

      _tmp1 = arr[i][str1];

      _arr.push(_t);
      _t = [arr[i]];
    }
  }
  // 将最后的内容推出新数组
  _arr.push(_t);
  return _arr;
}

/**
 * @param { Object } vm： this
 * @param { String } type: 查价类型
 * @param { Array } chooseCargoList: 选中的货物ID
 * @description: 设置记住货物信息
 */
export function setRememberCargoInfo(vm, type, chooseCargoList) {
  let cargoTypeList = {
    // 货物订单类型
    exp: 1,
    specialLine: 6,
    air: 3,
    fba: 20,
  };
  return new Promise(async (resolve, reject) => {
    const url = vm.$api04 + "Basics/api/Freight/InsertFreight";
    let customerID = getCookie("customerID")
      ? Number(getCookie("customerID"))
      : 0;
    let param = {
      CustomerID: customerID,
      WaybillType: cargoTypeList[type],
      CargoID: chooseCargoList,
    };

    const res = await post(url, param);
    if (res.IsOK) {
      console.log(res);
      //  res.Results.forEach((item) => {
      //   this.rememberCargoList.push(Number(item.CargoID));
      //  });
      //  if (this.rememberCargoList.length > 0) {
      //     this.chooseCargoList = this.rememberCargoList;
      //     this.isRememberCargo = true;
      //   }
    } else {
      vm.$message({
        type: "error",
        message: res.Message,
      });
    }

    return resolve();
  });
}
/**
 * @param { Object } vm： this
 * @param { String } type: 查价类型
 * @return { Array } 选中货物数组
 * @description: 设置记住货物信息
 */
export function getRememberCargoInfo(vm, type) {
  let cargoTypeList = {
    // 货物订单类型
    exp: 1,
    specialLine: 6,
    air: 3,
    fba: 20,
  };
  return new Promise(async (resolve, reject) => {
    const url = vm.$api04 + "Basics/api/Freight/SelFreight";
    let customerID = getCookie("customerID")
      ? Number(getCookie("customerID"))
      : 0;
    let param = {
      CustomerID: customerID,
      WaybillType: cargoTypeList[type],
    };

    let rememberCargoList = [];

    const res = await post(url, param);
    if (res.IsOK) {
      res.Results.forEach((item) => {
        rememberCargoList.push(Number(item.CargoID));
      });

      return resolve(rememberCargoList);
      // if (this.rememberCargoList.length > 0) {
      //     this.chooseCargoList = this.rememberCargoList;
      //     this.isRememberCargo = true;
      //     }
    }
  });
}

/**
 * 下单判断：后台员工账号禁止点击下单按钮
 * @param { Object } vm: 代表this
 * @return { Boolean } true || false
 */
export function clickOrder(vm, message = "员工账号请在业务后台操作下单") {
  return new Promise((resolve, reject) => {
    let user = getCookie("UserFrom");
    if (user == "U") {
      // 弹出员工登录去后台查价提示
      vm.$message({
        message: message,
        duration: 3000,
        // customClass: 'check-login-message'
      });
      // 阻止继续事件绑定函数
      return resolve(false);
    }
    return resolve(true);
  });
}

/**
 * @desc 数据类型检测
 * @param obj 待检测的数据
 * @return {String} 类型字符串
 */
export function dataType(obj) {
  return typeof obj !== "object"
    ? typeof obj
    : Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
}

/**
 * 防抖函数
 */
export function debounce(fun, delay) {
  return function (args) {
    let that = this;
    let _args = args;
    clearTimeout(fun.id);
    fun.id = setTimeout(function () {
      fun.call(that, _args);
    }, delay);
  };
}

/**
 * 节流函数
 */
export function throttle(func, wait) {
  let timeout;
  return function () {
    let context = this;
    let args = arguments;
    if (!timeout) {
      timeout = setTimeout(() => {
        timeout = null;
        func.apply(context, args);
      }, wait);
    }
  };
}

//计算两个日期之间相差的天数
export function getDiffDay(date_1, date_2) {
  // 计算两个日期之间的差值
  let totalDays, diffDate;
  let myDate_1 = Date.parse(date_1);
  let myDate_2 = Date.parse(date_2);
  // 将两个日期都转换为毫秒格式，然后做差
  diffDate = Math.abs(myDate_1 - myDate_2); // 取相差毫秒数的绝对值

  totalDays = Math.floor(diffDate / (1000 * 3600 * 24)); // 向下取整
  // console.log(totalDays)

  return totalDays; // 相差的天数
}

// 判断是否是已认证的用户, 获取用户信息
export function getAccountInfo(vm, type = 0) {
  return new Promise(async (resolve, reject) => {
    if (true) {
      // 判断是否存在用户信息

      // if (sessionStorage.getItem('SalesInfos') && ![null, 'null', undefined, 'undefined'].includes(sessionStorage.getItem('SalesInfos'))) {
      //     return resolve(JSON.parse(sessionStorage.getItem('SalesInfos') || ''));
      // }
      if (type == 0) {
        if (
          getCookie("CustomerInfo") &&
          ![null, "null", undefined, "undefined"].includes(
            getCookie("CustomerInfo")
          )
        ) {
          let CustomerInfo = getCookie("CustomerInfo");
          sessionStorage.setItem("loginMessage", CustomerInfo);
          sessionStorage.setItem("SalesInfos", CustomerInfo);
          return resolve(JSON.parse(CustomerInfo || ""));
        }
      }

      // await post(vm.$api02 + '/api/CustomerInfo/GetCustomerInfoByToken', {}).then(res => {
      //     if (res.IsOK) {
      //         sessionStorage.setItem('loginMessage', JSON.stringify(res.Results))
      //         return resolve(res.Results || {});
      //     } else {
      //         return resolve({});
      //     }
      // }).catch(err => {
      //     return resolve({});
      // });
      // return resolve({});
      // await post(vm.$api02 + '/api/CustomerInfo/GetCustomerInfoByToken', {}).then(res => {
      await post(
        vm.$api04 + "Basics/api/CustomerInfo/GetCustomerInfoByToken",
        {}
      )
        .then((res) => {
          if (res.IsOK) {
            setCookie("CustomerInfo", JSON.stringify(res.Results));
            sessionStorage.setItem("loginMessage", JSON.stringify(res.Results));
            sessionStorage.setItem("SalesInfos", JSON.stringify(res.Results));
            return resolve(res.Results || {});
          } else {
            return resolve({});
          }
        })
        .catch((err) => {
          return resolve({});
        });
      return resolve({});
    } else {
      return reject();
    }
  });
}

/**
 * @description 下载
 */
function downloadMulti(name, url) {
  return new Promise((resolve, reject) => {
    if (true) {
      var aDom = document.createElement("a");
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", false, false);
      aDom.download = name;
      let href = url;
      if (typeof url == "string") {
        aDom.target = "_blank"; //如果是链接,打开新标签页下载
      } else {
        href = window.URL.createObjectURL(url); //创建下载的链接
      }
      aDom.href = href;
      aDom.dispatchEvent(evt);
      aDom.click();

      return resolve(true);
    } else {
      return reject();
    }
  });
}

/**
 * @description 下载pdf
 * @param param { object } 参数
 * @param param.bankId { string | number } 银行ID
 * @param param.orderNo { string } 订单号
 * @param param.orderType { string } 订单类型
 */
export function downloadPDF(vm, param) {
  // 全屏加载
  let loading = vm.$loading({
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  let typeList = {
    exp: 1,
    fba: 20,
    air: 3,
    sea: 5,
    seaFull: 4,
  };
  let url = vm.$api04 + "Bill/api/CustomerBill/BillExportPdf";
  let params = {
    AccountID: Number(param.bankId), // 银行ID
    WaybillNO: param.orderNo, // 订单号
    WaybillType: typeList[param.orderType], // 订单类型
  };
  post(url, params)
    .then((res) => {
      if (res.IsOK) {
        //   downloadMulti(param.orderNo + '_账单.pdf', vm.$apiFileCloud.slice(0, -1) + res.Results).then(res => {
        //     // 停止加载
        //     loading.close();
        //   }).catch(err => {
        //     // 停止加载
        //     loading.close();
        //   });
        let urlFileList = res.Results.split("/");
        fileSteamDownload(
          vm,
          {
            FullPath: res.Results, // 路径
            CurrentFileName: urlFileList[urlFileList.length - 1], // 文件名称
          },
          param.orderNo + "_账单.pdf"
        );
        loading.close();
      } else {
        vm.$message({
          type: "error",
          message: res.Message,
        });
        // 停止加载
        loading.close();
      }
    })
    .catch((err) => {
      console.log(err);
    });
}

// 手机号正则
export const mobilePhoneRegExp = /^1\d{10}$/;
// 邮箱正则
export const emailRegExp = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
// 手机号和固定电话正则
export const telRegExp = /^(\d+-{0,1}\d+)(-{0,1}\d+)?$/;

// 正则匹配中文，英文，数字
export const nameRegExp = /^(?!_)(?!.*?_$)[a-zA-Z0-9\u4e00-\u9fa5]{1,20}$/;
export const nameRegExp10 = /^(?!_)(?!.*?_$)[a-zA-Z0-9\u4e00-\u9fa5]{1,10}$/;
// 正则匹配汉字
export const chineseExp = /[\u4e00-\u9fa5]/;
// 正则匹配正整数
export const intExp = /^\d+$/;
/**
 * @param { string } value: 字符串
 * @param { number } intLen: 要截取多少位整数
 * @param { number } len: 要截取多少位小数
 * @return 一个浮点数
 */
export function floatNumber(value, intLen, len) {
  return new Promise((resolve) => {
    if (value) {
      // if (isNaN(Number(value))) {
      //   return resolve('');
      // }
      value = value.replace(/[^\d\.]/g, "");
      // 判断是否还有小数点
      if (value.indexOf(".") != -1) {
        // 截取小数点后面的字符串
        let strLen = value.substring(value.indexOf(".") + 1);

        if (strLen.length >= len) {
          // 如果小数点后的位数大于要截取的
          value = value.substring(0, value.indexOf(".") + len + 1);
        } else {
          value = value.substring(0, value.indexOf(".") + strLen.length + 1);
        }
      }
      let arr = value.split(".");
      let beforeLen = arr[0].length;
      //获取小数点前面的值
      if (value.indexOf(".") != -1) {
        if (beforeLen > intLen) {
          let int = arr[0].substring(0, 8);
          if (value.indexOf(".") > -1) {
            value = int + "." + arr[1];
          } else {
            value = int;
          }
        }
      } else {
        if (beforeLen > intLen) {
          value = arr[0].slice(0, intLen);
        }
      }

      return resolve(value);
    }
  });
}

/**
 * description: 网站不同源下载，设置下载文件名称
 * @param { String } url: 下载路径
 * @param { String } fileName: 下载文件名字
 */
export function downloadFileNotOrigin(url, fileName) {
  const xhr = new window.XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = () => {
    const url = window.URL.createObjectURL(xhr.response);
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.download = fileName;
    a.style.display = "none";
    document.body.append(a);
    a.click();
  };
  xhr.send();
}

/**
 * @description 判断客户是否首次下单
 * @param { Object } vm this
 * @return { Boolean }
 */
export function IsFirstOrder(vm) {
  return new Promise(async (resolve, reject) => {
    if (true) {
      await fetch(vm.$api04 + "Basics/api/Customer/QueryTimeInfo", {})
        .then((res) => {
          console.log("======判断客户是否首次下单", res);
          if (res.IsOK) {
            return resolve(res.Results);
          }
          return resolve({});
        })
        .catch((err) => {
          return resolve({});
        });
    } else {
      reject();
    }
  });
}

export function IsFirstSuccessOrder(vm, orderId) {
  return new Promise(async (resolve, reject) => {
    if (true) {
      await fetch(vm.$api04 + "Basics/api/Customer/IsFirstOrder", {
        WaybillNO: orderId,
      })
        .then((res) => {
          return resolve(res.Results);
        })
        .catch((err) => {
          return resolve({});
        });
    } else {
      reject();
    }
  });
}

/**
 * @description 判断是否是业务员
 * @param { Object } customerInfo 用户信息
 * @param { Object } vm this
 * @return { Boolean }
 */
export function isAccountToSalesman(customerInfo, vm) {
  return new Promise((resolve, reject) => {
    if (true) {
      if (customerInfo.UserFrom == "U") {
        let isRole = false;
        if (customerInfo.RoleName) {
          let RoleNameList = [];
          RoleNameList = customerInfo.RoleName.split(",");
          isRole =
            RoleNameList.filter((item) =>
              ["业务员", "海外业务员"].includes(item)
            ).length > 0
              ? true
              : false;
        }
        if (!customerInfo.IsGroupSaleAccount && isRole) {
          // 是业务员
          return resolve({
            isFalse: true,
            isSalesman: true,
          });
        }
        // 不是业务员, 是员工
        vm.$message({
          type: "info",
          message: "没有菜单权限",
          duration: 3000,
        });
        return resolve({
          isFalse: false,
          isSalesman: false,
        });
      } else {
        // 不是员工
        return resolve({
          isFalse: true,
          isSalesman: false,
        });
      }
    } else {
      return reject();
    }
  });
}
/**
 * 判断是否是微信内置浏览器
 */
function isWxChatBrowser() {
  var ua = window.navigator.userAgent.toLowerCase();
  //console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //是微信浏览器
    return true;
  } else {
    return false;
  }
}

export { isWxChatBrowser };

/**
 * @param type 跳转类型 1：本页面跳转；2：新开页面跳转； 3：下载
 * @param href 跳转链接
 * @param fileName 下载时文件名
 * @description 解决浏览器执行不了window.open和window.location.href的跳转
 */
function browserHref(href, type = 1, fileName = "") {
  // 创建一个a标签下载文件
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = href;
  // 设置a标签target属性
  if (type == 2) {
    link.setAttribute("target", "_blank");
  }
  // 设置文件名称、后缀名
  if (type == 3) {
    link.setAttribute("download", fileName);
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export { browserHref };



// WEBPACK FOOTER //
// ./src/util/util.js